<script>
import { mapGetters } from 'vuex'
import { getLogoURLs} from "@/helpers/logo";

export default {
  name: 'InfoHeader',
  computed: {
    ...mapGetters(['locale']),
    logoURL() {
      return getLogoURLs()
    },
    isMobile: function() {
      return this.$vuetify.breakpoint.name === 'xs'
    }
  }
}
</script>
<template>
  <v-app-bar elevation="0" color="rgba(0,0,0,0)" height="105">
    <v-card flat tile color="white" :class="isMobile ? '' : 'ml-10'">
      <v-toolbar-title>
        <router-link :to="{ name: 'homepage', params: { locale: locale } }">
          <img
            id="logo-header"
            :src="logoURL.navbar"
            width="136"
            alt="info header logo"
          />
        </router-link>
      </v-toolbar-title>
    </v-card>
  </v-app-bar>
</template>
